import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/tokens.css';
import '@/styles/global.css';
import { App } from './App';

/**
 * 默认打真实 apiserver，不走 Mock。
 *
 * 之前是「DEV 默认开 MSW」，那会让前端看起来一切正常，
 * 实际上从没和后端对过一次——契约漂移到 60 个端点对不上都无人察觉。
 * 现在反过来：必须显式设 `VITE_USE_MSW=1` 才启用，
 * 且仅限本地开发。默认失败比默认假成功有价值得多。
 */
async function enableMocking(): Promise<void> {
  if (!import.meta.env.DEV) return;
  if (import.meta.env['VITE_USE_MSW'] !== '1') return;
  const { worker } = await import('@/mocks/browser');
  // 未登记的请求直接报错而不是静默放行：
  // bypass 会让「前端调了一个没人实现的接口」看起来像网络问题。
  await worker.start({ onUnhandledRequest: 'warn' });
}

const root = document.getElementById('root');
if (!root) throw new Error('#root 不存在，index.html 被改坏了');

void enableMocking().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
